import {
  GET_BUSINESS_OVERVIEW_DATA,
  GET_BUSINESS_OVERVIEW_DATA_SUCCESS,
  GET_BUSINESS_OVERVIEW_DATA_ERROR,
} from "./actionType";

// Get Business Overview dashboard data for a date range
export const getBusinessOverviewData = (data) => ({
  type: GET_BUSINESS_OVERVIEW_DATA,
  payload: data,
});

export const getBusinessOverviewDataSuccess = (data) => ({
  type: GET_BUSINESS_OVERVIEW_DATA_SUCCESS,
  payload: data,
});

export const getBusinessOverviewDataError = (error) => ({
  type: GET_BUSINESS_OVERVIEW_DATA_ERROR,
  payload: error,
});
